<template>
  <div
    v-if="hasOptions"
    :data-selected-speciality-id="selectValue.id"
    :data-appointment-type-redirect="appointmentTypeRedirect"
    class="mb-4"
  >
    <SelectModuleButton
      :class="isMobile ? 'py-2' : 'py-1'"
      :title="selectValue.name"
      @click="handleClickSelect"
    />
  </div>
</template>

<script>
import { dispatchCustomEventGlobally } from 'www/utils'
import SelectModuleButton from 'www/vue_components/common/SelectModule/SelectModuleModal/components/common/SelectModuleButton.vue'

export default {
  name: 'LpuSpecialityList',
  components: {
    SelectModuleButton,
  },
  props: {
    lpuId: {
      type: [Number, null],
      default: null,
    },
    options: {
      type: Array,
      default: () => [],
    },
    selectedOption: {
      type: [Object, null],
      default: () => null,
    },
  },
  data() {
    return {
      isMobile: window.MOBILE_VERSION,
      selectValue: this.selectedOption || this.options[0] || {},
    }
  },
  computed: {
    hasOptions() {
      return !!this.options.length
    },
    appointmentTypeRedirect() {
      return this.selectValue.is_in_club ? 'club' : 'default'
    },
  },
  mounted() {
    window.addEventListener('lpu-speciality-list:select-option', ({
      detail: {
        lpuId,
        option,
      },
    }) => {
      if (this.lpuId === lpuId) {
        this.selectValue = option
      }
    })
  },
  methods: {
    handleClickSelect() {
      dispatchCustomEventGlobally('lpu-speciality-list:open-dialog', {
        target: this.$el,
        lpuId: this.lpuId,
        options: this.options,
      })
    },
  },
}
</script>
